import React, { useState, useEffect, useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import {
  ChevronRight,
  ChevronLeft,
  BarChart3,
  Lock,
  KeyRound,
  Download,
  Eye,
  ArrowLeft,
  Loader2,
  Search,
  Trash2,
} from "lucide-react";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  onSnapshot,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";

// --- DIN FIREBASE KONFIGURASJON ---
const firebaseConfig = {
  apiKey: "AIzaSyAb6YgRFHh9494WBho7hfoTdZe51YgLrHg",
  authDomain: "egogramprofil.firebaseapp.com",
  projectId: "egogramprofil",
  storageBucket: "egogramprofil.firebasestorage.app",
  messagingSenderId: "759494469643",
  appId: "1:759494469643:web:6be3f1dc9a95d6c8b5ff0e",
  measurementId: "G-D17N9EQB54",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const DB_COLLECTION = "egogram_analyses";

// --- SPØRSMÅLSDATA ---
const questions = [
  { id: 1, text: "Jeg er imøtekommende og forståelsesfull når andre har problemer.", cat: "OF" },
  { id: 2, text: "Jeg har bestemte meninger, og det skal mye til før jeg forandrer de.", cat: "KF" },
  { id: 3, text: "En av de største gledene jeg har i livet er å tilfredsstille andre menneskers behov.", cat: "OF" },
  { id: 4, text: "Tradisjoner, skikk og bruk betyr mye for meg.", cat: "KF" },
  { id: 5, text: "Jeg er overbærende og har lett for å tilgi andre.", cat: "OF" },
  { id: 6, text: "Jeg er krevende og kritisk når det gjelder å pålegge andre mennesker oppgaver.", cat: "KF" },
  { id: 7, text: "Jeg tror dat alle mennesker er gode på bunnen.", cat: "OF" },
  { id: 8, text: "Jeg tar ofte lederrollen fordi jeg vet best hva som bør gjøres.", cat: "KF" },
  { id: 9, text: "En av de største gledene jeg har i livet er å hjelpe andre til å realisere og utvikle evnene sine.", cat: "OF" },
  { id: 10, text: "Jeg føler det er en plikt å bruke min styrke og viten til å beskytte andre som er svakere enn meg selv.", cat: "KF" },
  { id: 11, text: "Mennesker som har problemer ber meg ofte om råd og hjelp.", cat: "OF" },
  { id: 12, text: "Hvis jeg oppdager at noen har gjort noe galt, vil jeg føle det som en plikt å sørge for at de får sin rettmessige straff.", cat: "KF" },
  { id: 13, text: "Oppdager jeg at noen har problemer med å få utført en oppgave, vil jeg helst overta og gjøre den istedenfor dem.", cat: "OF" },
  { id: 14, text: "Jeg har en bestemt oppfatning av hva som er riktig og galt, og jeg vil ikke nøle med å bedømme andre på dette grunnlag.", cat: "KF" },
  { id: 15, text: "Når noen trenger hjelp, kommer jeg gjerne til unnsetning.", cat: "OF" },
  { id: 16, text: "Hvis det er nødvendig, tar jeg gjerne hardt i for å få folk til å gjøre det de burde gjøre.", cat: "KF" },
  { id: 17, text: "Jeg føler meg ofte engstelig og redd.", cat: "TB" },
  { id: 18, text: "Jeg er et stemningsmenneske og handler ofte uten at jeg får tenkt meg om.", cat: "NB" },
  { id: 19, text: "Min tankemåte er rasjonell og logisk.", cat: "V" },
  { id: 20, text: "Jeg føler meg ofte trist, deprimert og tung til sinns.", cat: "TB" },
  { id: 21, text: "Jeg liker ikke å vente på noe jeg har lyst på. Jeg vil ha det jeg ønsker når jeg ønsker det.", cat: "NB" },
  { id: 22, text: "Står jeg overfor et problem, er jeg vanligvis rolig og avbalansert.", cat: "V" },
  { id: 23, text: "Det er viktig for meg alltid å strebe etter å gjøre ting så perfekt som overhodet mulig.", cat: "TB" },
  { id: 24, text: "Jeg er en sensuell person.", cat: "NB" },
  { id: 25, text: "Jeg vurderer alltid de faktiske forhold før jeg tar en avgjørelse.", cat: "V" },
  { id: 26, text: "Jeg er flink til å forstå hva andre mennesker ønsker og til å innrette meg deretter for å glede dem.", cat: "TB" },
  { id: 27, text: "Jeg føler det er best å alltid adlyde folk med autoritet.", cat: "TB" },
  { id: 28, text: "Jeg liker spenning og at det foregår stimulerende ting rundt meg.", cat: "NB" },
  { id: 29, text: "Jeg er vel underrettet og oppfatter hurtig sakens kjerne.", cat: "V" },
  { id: 30, text: "Jeg er hissig og blir ofte sint.", cat: "TB" },
  { id: 31, text: "Jeg er oppfinnsom og har masse gode ideer.", cat: "NB" },
  { id: 32, text: "Jeg er mottagelig for nye tanker og andres synspunkter på alt mulig.", cat: "V" },
  { id: 33, text: "Når noen forteller meg hva jeg skal gjøre, gjør jeg ofte det motsatte.", cat: "TB" },
  { id: 34, text: "Jeg er en spennende og livlig person.", cat: "NB" },
  { id: 35, text: "Jeg arbeider systematisk og ordentlig, og jeg planlegger alt på forhånd.", cat: "V" },
  { id: 36, text: "Hvis noen gjør meg urett, blir jeg langsint.", cat: "TB" },
  { id: 37, text: "Jeg er nysgjerrig og liker å utforske nye tinh.", cat: "NB" },
  { id: 38, text: "Jeg blir ofte nedfor av hva folk kan si og foreta seg.", cat: "TB" },
  { id: 39, text: "Jeg har ikke noe imot å lure andre litt for å få det som jeg vil.", cat: "TB" },
  { id: 40, text: "Jeg er kjent for å være objektiv og rettferdig.", cat: "V" },
  { id: 41, text: "Jeg er en meget åpen person og er ikke opptatt av å skjule mine følelser.", cat: "NB" },
  { id: 42, text: "Jeg prøver å holde masken, selv om jeg innvendig føler meg såret.", cat: "TB" },
  { id: 43, text: "Jeg har et livlig sinn og er en spontan person.", cat: "NB" },
  { id: 44, text: "Jeg er flink til å beskrive ting nøyaktig slik at andre mennesker lett forstår hva jeg mener.", cat: "V" },
  { id: 45, text: "Jeg er klosset og dum.", cat: "TB" },
  { id: 46, text: "Jeg føler meg hjelpeløs og ute av stand til å håndtere mange situasjoner.", cat: "TB" },
  { id: 47, text: "Jeg gjør mitt beste for å leve opp til de forventninger andre har til meg.", cat: "TB" },
  { id: 48, text: "Når noen er sinte på meg, prøver jeg å vise en forsonlig holdning.", cat: "TB" },
  { id: 49, text: "Jeg er en spøkefugl, full av moro.", cat: "NB" },
  { id: 50, text: "Står jeg overfor mennesker med ekstremt ulike standpunkter, vil jeg som regel prøve å få i stand et kompromiss mellom dem.", cat: "V" },
];

const categoryInfo = {
  KF: {
    name: "Kritisk forelder",
    color: "#a68a8a",
    label: "Struktur & Retning",
    desc: "Denne tilstanden handler om verdier, grenser og kvalitetssikring. En tydelig søyle her viser styrke i å gi retning og sette standarder. Fallgruven ved svært høy energi er å bli for kontrollerende eller dømmende. Er søylen lav, kan det bety at du er svært aksepterende, men kanskje utydelig når det kreves korrigering.",
  },
  OF: {
    name: "Omsorgsfull forelder",
    color: "#8ca09a",
    label: "Omsorg & Støtte",
    desc: "Her ligger evnen til å lytte, utvikle andre og skape trygghet. Høy energi gjør deg til en støttende leder som bygger tillit, men pass på så du ikke overtar andres ansvar. Lav energi her kan tyde på en svært profesjonell og saklig stil som fungerer godt i kriser, men som kan oppleves som distansert i hverdagen.",
  },
  V: {
    name: "Voksen",
    color: "#8a96a3",
    label: "Logikk & Analyse",
    desc: "Dette er den rasjonelle delen som tar beslutninger basert på fakta her-og-nå. En solid voksen-søyle gir deg oversikt og objektivitet. For mye fokus her kan gjøre kommunikasjonen tørr og uten emosjonell resonans. Er søylen lavere enn de andre, styres du kanskje mer av intuisjon og følelser enn av ren logikk.",
  },
  NB: {
    name: "Naturlig barn",
    color: "#c2ab8f",
    label: "Kreativitet & Energi",
    desc: "Kilden til entusiasme, nysgjerrighet og spontan energi. Dette er din indre innovatør. Høy verdi sprer glede og energi to teamet, men kan mangle utholdenhet i rutineoppgaver. En lav søyle kjennetegner ofte en svært behersket og kontrollert leder, men som kanskje kan fremstå som litt for alvorlig over tid.",
  },
  TB: {
    name: "Tilpasset barn",
    color: "#9992a1",
    label: "Samarbeid & Lojalitet",
    desc: "Denne tilstanden handler om evnen til å være en lagspiller og følge felles kjøreregler. Høy energi viser stor vilje til samarbeid og smidighet, men kan gjøre det vanskelig å ta upopulære beslutninger. Lav energi indikerer en uavhengig og selvstendig leder som tør å gå mot strømmen når det trengs.",
  },
};

export default function App() {
  const [user, setUser] = useState(null);
  const [view, setView] = useState("welcome");
  const [candidate, setCandidate] = useState({ name: "", email: "" });
  const [answers, setAnswers] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [allAnalyses, setAllAnalyses] = useState([]);
  const [search, setSearch] = useState("");
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: "", password: "" });
  const [loginError, setLoginError] = useState("");
  const [activeAnalysis, setActiveAnalysis] = useState(null);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [triggerSave, setTriggerSave] = useState(false);

  useEffect(() => {
    onAuthStateChanged(auth, setUser);
    const logIn = async () => {
      try {
        await signInAnonymously(auth);
      } catch (e) {
        console.error(e);
      }
    };
    logIn();
  }, []);

  const results = useMemo(() => {
    if (activeAnalysis) return activeAnalysis.results;
    const raw = { KF: 0, OF: 0, V: 0, NB: 0, TB: 0 };
    const counts = { KF: 0, OF: 0, V: 0, NB: 0, TB: 0 };
    questions.forEach((q) => {
      const score = answers[q.id] || 0;
      raw[q.cat] += score;
      counts[q.cat] += 1;
    });
    return Object.keys(raw).map((key) => ({
      key,
      name: categoryInfo[key].name,
      label: categoryInfo[key].label,
      profile: counts[key] > 0 ? Math.round((raw[key] / (counts[key] * 5)) * 100) : 0,
      color: categoryInfo[key].color,
      desc: categoryInfo[key].desc,
    }));
  }, [answers, activeAnalysis]);

  const resetTest = () => {
    setAnswers({});
    setCurrentIndex(0);
    setCandidate({ name: "", email: "" });
    setActiveAnalysis(null);
    setView("welcome");
  };

  const viewAnalysisFromAdmin = (item) => {
    setActiveAnalysis(item);
    setCandidate({ name: item.name, email: item.email });
    setView("results");
  };

  const deleteFromAdmin = async (id) => {
    if (!window.confirm("Vil du slette denne analysen permanent fra arkivet?")) return;
    try {
      await deleteDoc(doc(db, DB_COLLECTION, id));
    } catch (e) {
      console.error("Sletting feilet:", e);
    }
  };

  useEffect(() => {
    if (triggerSave) {
      const doSave = async () => {
        try {
          await addDoc(collection(db, DB_COLLECTION), {
            name: candidate.name || "Ukjent",
            email: candidate.email || "Ukjent",
            timestamp: new Date().toISOString(),
            results: results,
            userId: user ? user.uid : "anonym",
          });
        } catch (e) {
          console.error(e);
        } finally {
          setTimeout(() => {
            setTriggerSave(false);
            setView("results");
          }, 1200);
        }
      };
      doSave();
    }
  }, [triggerSave, candidate, results, user]);

  useEffect(() => {
    if (!isAdminAuthenticated || view !== "admin") return;
    return onSnapshot(collection(db, DB_COLLECTION), (s) => {
      const d = s.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setAllAnalyses(d.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)));
    });
  }, [view, isAdminAuthenticated]);

  const handleAnswer = (v) => {
    const nextAnswers = { ...answers, [questions[currentIndex].id]: v };
    setAnswers(nextAnswers);
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setView("processing");
      setTimeout(() => setTriggerSave(true), 800);
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (
      loginForm.username.toLowerCase() === "admin" &&
      loginForm.password === "Egogram2026!"
    ) {
      setIsAdminAuthenticated(true);
      setLoginError("");
      setView("admin");
    } else {
      setLoginError("Feil brukernavn eller passord");
    }
  };

  const generatePDF = async () => {
    setIsGeneratingPDF(true);
    try {
      if (!window.html2pdf) {
        const s = document.createElement("script");
        s.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
        await new Promise((r) => {
          s.onload = r;
          document.head.appendChild(s);
        });
      }
      const el = document.getElementById("pdf-report");
      const safeName = candidate.name ? candidate.name.replace(/[^a-zA-Z0-9æøåÆØÅ]/g, "_") : "Profil";
      await window
        .html2pdf()
        .set({
          margin: [15, 10],
          filename: `Egogram_${safeName}.pdf`,
          image: { type: "jpeg", quality: 1.0 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(el)
        .save();
    } catch (e) {
      alert("PDF-feil");
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  if (view === "welcome") {
    return (
      <div className="min-h-screen bg-[#fdfcfb] flex items-center justify-center p-4 font-sans text-stone-800">
        <div className="max-w-3xl w-full bg-white rounded-3xl shadow-sm p-8 md:p-14 border border-stone-100 overflow-y-auto max-h-[95vh]">
          <div className="flex justify-between items-center mb-8">
            <BarChart3 className="text-stone-300" size={56} strokeWidth={1.5} />
            {/* Tydeligere og mer profesjonell Admin-knapp */}
            <button
              onClick={() => setView("login")}
              className="text-stone-500 hover:text-stone-800 px-3 py-1.5 rounded-lg bg-stone-50 hover:bg-stone-100 border border-stone-200 transition-all flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider shadow-sm"
            >
              <Lock size={14} /> Admin
            </button>
          </div>

          <h1 className="text-3xl md:text-4xl font-serif mb-8 text-stone-900 tracking-tight leading-tight">
            Velkommen til Egogram-kartlegging
          </h1>

          <div className="space-y-6 text-stone-600 leading-relaxed mb-10">
            <div className="space-y-4">
              <p>
                I analysen er det <strong>50 ulike påstander</strong>. Du skal ta stilling til hvor godt hver enkelt beskrivelse passer deg.
              </p>
              <p>
                Ingen svar er riktige eller gale. Mennesker vil i større eller mindre grad kunne kjenne seg igjen i de fleste av de beskrevne måter å være på.
              </p>
              <p>
                Prøv å vær ærlig overfor deg selv. Glatt ikke over feil og vær samtidig ikke redd for å få frem dine gode sider. <strong>Ditt umiddelbare svar vil være det riktigste.</strong>
              </p>
              <p>
                I og med at ingen person er den samme bestandig, skal du besvare skjemaet i henhold til hvordan du som regel opptrer i dagligdagse situasjoner relatert til jobb.
              </p>
            </div>

            <div className="bg-stone-50 p-6 rounded-2xl border border-stone-100 italic text-sm">
              Basert på Transaksjonsanalysen (Utviklet av <strong>Eric Berne</strong>). Transaksjonsanalysen beskriver teorien om hvordan vi opererer ut fra ulike egotilstander. Et Egogram gir deg innsikt i din lederstil og dine reaksjonsmønstre. Målet er bevisstgjøring for å oppnå et balansert lederskap og god kommunikasjon som leder.
            </div>

            <div className="pt-4 border-t border-stone-100">
              <h2 className="font-bold text-stone-800 mb-3 uppercase tracking-widest text-xs">
                Slik vurderer du påstandene:
              </h2>
              <div className="grid grid-cols-5 gap-2 text-[10px] sm:text-xs font-bold text-center">
                <div className="p-2 bg-stone-100 rounded">1<br />Slett ikke</div>
                <div className="p-2 bg-stone-100 rounded">2<br />Så vidt</div>
                <div className="p-2 bg-stone-100 rounded">3<br />Nokså bra</div>
                <div className="p-2 bg-stone-100 rounded">4<br />Ganske bra</div>
                <div className="p-2 bg-stone-800 text-white rounded shadow-md">5<br />Spesielt bra</div>
              </div>
            </div>
          </div>

          <button
            onClick={() => setView("registration")}
            className="w-full bg-stone-800 text-white py-5 rounded-2xl font-bold shadow-xl hover:bg-stone-900 hover:-translate-y-0.5 transition-all flex items-center justify-center gap-3"
          >
            Start kartleggingen <ChevronRight size={20} />
          </button>
        </div>
      </div>
    );
  }

  if (view === "login") {
    return (
      <div className="min-h-screen bg-[#fdfcfb] flex items-center justify-center p-6 text-stone-800 font-sans">
        <div className="max-w-md w-full bg-white rounded-3xl shadow-sm p-10 border border-stone-100">
          <button
            onClick={() => setView("welcome")}
            className="mb-8 text-stone-400 hover:text-stone-600 flex items-center gap-1 text-sm transition-colors"
          >
            <ArrowLeft size={16} /> Tilbake
          </button>
          <div className="flex justify-center mb-6">
            <KeyRound size={40} className="text-stone-800" />
          </div>
          <h2 className="text-2xl font-serif mb-8 text-center">Administrasjon</h2>
          <form className="space-y-6" onSubmit={handleLogin}>
            <input
              required
              type="text"
              value={loginForm.username}
              onChange={(e) => setLoginForm({ ...loginForm, username: e.target.value })}
              className="w-full px-5 py-4 bg-stone-50 rounded-xl border border-stone-100 outline-none focus:border-stone-300 transition-colors"
              placeholder="Brukernavn"
            />
            <input
              required
              type="password"
              value={loginForm.password}
              onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
              className="w-full px-5 py-4 bg-stone-50 rounded-xl border border-stone-100 outline-none focus:border-stone-300 transition-colors"
              placeholder="Passord"
            />
            {loginError && (
              <p className="text-red-500 text-xs text-center font-bold">{loginError}</p>
            )}
            <button type="submit" className="w-full bg-stone-800 text-white py-5 rounded-xl font-medium hover:bg-stone-900 transition-colors shadow-md">
              Logg inn
            </button>
          </form>
        </div>
      </div>
    );
  }

  if (view === "registration") {
    return (
      <div className="min-h-screen bg-[#fdfcfb] flex items-center justify-center p-6 text-stone-800 font-sans">
        <div className="max-w-md w-full bg-white rounded-3xl shadow-sm p-10 border border-stone-100">
          <button
            onClick={() => setView("welcome")}
            className="mb-6 text-stone-400 flex items-center gap-1 text-sm hover:text-stone-600 transition-colors"
          >
            <ArrowLeft size={16} /> Tilbake
          </button>
          <h2 className="text-2xl font-serif mb-8 text-stone-900 tracking-tight">Vennligst oppgi informasjon</h2>
          <form
            className="space-y-6"
            onSubmit={(e) => {
              e.preventDefault();
              setView("test");
            }}
          >
            <div className="space-y-1">
              <label className="text-[10px] font-black uppercase text-stone-400 ml-1">Ditt fulle navn</label>
              <input
                required
                type="text"
                value={candidate.name}
                onChange={(e) => setCandidate({ ...candidate, name: e.target.value })}
                className="w-full px-5 py-4 bg-stone-50 rounded-xl border border-stone-100 outline-none focus:border-stone-300 transition-colors"
                placeholder="Ola Nordmann"
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-black uppercase text-stone-400 ml-1">E-postadresse</label>
              <input
                required
                type="email"
                value={candidate.email}
                onChange={(e) => setCandidate({ ...candidate, email: e.target.value })}
                className="w-full px-5 py-4 bg-stone-50 rounded-xl border border-stone-100 outline-none focus:border-stone-300 transition-colors"
                placeholder="navn@epost.no"
              />
            </div>
            <button type="submit" className="w-full bg-stone-800 text-white py-5 rounded-xl font-bold shadow-lg hover:bg-stone-900 transition-all">
              Gå til spørsmålene
            </button>
          </form>
        </div>
      </div>
    );
  }

  if (view === "test") {
    const q = questions[currentIndex];
    return (
      <div className="min-h-screen bg-[#fdfcfb] p-6 flex flex-col items-center text-stone-800 font-sans">
        <div className="max-w-2xl w-full">
          <div className="flex justify-between items-end mb-4 text-stone-400 text-[10px] font-bold uppercase tracking-widest">
            <span>{candidate.name}</span>
            <span>{currentIndex + 1} / 50</span>
          </div>
          <div className="h-1 w-full bg-stone-100 rounded-full mb-12">
            <div
              className="h-full bg-stone-800 transition-all duration-300"
              style={{ width: `${((currentIndex + 1) / 50) * 100}%` }}
            ></div>
          </div>
          <div className="bg-white rounded-[2.5rem] p-8 sm:p-20 shadow-sm border border-stone-100 min-h-[400px] flex flex-col justify-center text-center">
            <h2 className="text-xl sm:text-2xl font-serif italic mb-12 sm:mb-16 leading-relaxed">
              "{q.text}"
            </h2>
            <div className="grid grid-cols-5 gap-2 sm:gap-4">
              {[1, 2, 3, 4, 5].map((v) => (
                <button
                  key={v}
                  onClick={() => handleAnswer(v)}
                  className="py-4 sm:py-6 bg-stone-50 hover:bg-stone-800 hover:text-white rounded-2xl transition-all font-bold text-xl text-stone-700 shadow-sm"
                >
                  {v}
                </button>
              ))}
            </div>
          </div>
          <button
            onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
            className={`mt-8 text-stone-400 hover:text-stone-800 flex items-center gap-2 text-sm font-medium ${
              currentIndex === 0 ? "opacity-0" : ""
            }`}
          >
            <ChevronLeft size={16} /> Forrige spørsmål
          </button>
        </div>
      </div>
    );
  }

  if (view === "processing") {
    return (
      <div className="min-h-screen bg-[#fdfcfb] flex flex-col items-center justify-center p-6 text-stone-800 font-sans">
        <Loader2 className="animate-spin text-stone-300 mb-6" size={48} />
        <p className="font-serif italic text-xl">Lagrer din profil...</p>
      </div>
    );
  }

  if (view === "results") {
    const cur = activeAnalysis ? activeAnalysis.results : results;
    return (
      <div className="min-h-screen bg-[#f3f2f1] p-4 md:p-6 text-stone-800 font-sans">
        <div className="max-w-5xl mx-auto mb-6 bg-white border border-stone-200 rounded-3xl p-6 flex flex-col sm:flex-row items-center justify-between gap-6 shadow-sm no-print">
          <div className="flex items-center gap-4">
            {activeAnalysis && (
              <button
                onClick={() => {
                  setActiveAnalysis(null);
                  setView("admin");
                }}
                className="p-3 bg-stone-100 rounded-full hover:bg-stone-200"
              >
                <ArrowLeft size={18} />
              </button>
            )}
            <h2 className="text-xl font-serif font-bold">Lederprofil</h2>
          </div>
          <button
            onClick={generatePDF}
            disabled={isGeneratingPDF}
            className="w-full sm:w-auto bg-stone-800 text-white px-8 py-3.5 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-stone-900 transition-all shadow-md disabled:opacity-70"
          >
            {isGeneratingPDF ? (
              <Loader2 size={18} className="animate-spin" />
            ) : (
              <Download size={18} />
            )}{" "}
            Last ned PDF
          </button>
        </div>

        <div
          id="pdf-report"
          className="max-w-5xl mx-auto bg-white rounded-[3rem] shadow-md border border-stone-200 overflow-hidden pb-12"
        >
          <div className="bg-stone-100/50 p-10 md:p-16 border-b border-stone-200 text-center">
            <h1 className="text-4xl font-serif text-stone-900 mb-4">Egogram Lederprofil</h1>
            <p className="text-stone-500 font-bold uppercase tracking-widest text-[10px]">
              {candidate.name} — {new Date().toLocaleDateString("no-NO")}
            </p>
          </div>
          <div className="p-10 md:p-16">
            <div className="mb-20">
              <h2 className="text-2xl font-serif italic mb-10 text-stone-800 border-l-4 border-stone-200 pl-4">
                Energifordeling
              </h2>
              <div className="h-[380px] w-full bg-white">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={cur}
                    margin={{ top: 30, right: 20, left: 10, bottom: 5 }}
                  >
                    {/* Skarpere og tydeligere linjer bak grafene */}
                    <CartesianGrid
                      strokeDasharray="3 3"
                      vertical={false}
                      stroke="#e7e5e4"
                    />
                    <XAxis
                      dataKey="name"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fill: "#57534e", fontSize: 12, fontWeight: 700 }}
                    />
                    {/* Viser Y-aksen for referanse på høydene */}
                    <YAxis 
                      domain={[0, 100]} 
                      tickCount={6} 
                      axisLine={false} 
                      tickLine={false} 
                      tick={{ fill: "#a8a29e", fontSize: 11 }} 
                    />
                    <Tooltip
                      cursor={{ fill: "#fcfcfc" }}
                      content={({ active, payload }) =>
                        active && payload ? (
                          <div className="bg-white p-3 shadow-xl border border-stone-100 rounded-lg">
                            <p className="text-sm font-serif font-bold">
                              {payload[0].payload.name}: {payload[0].value}%
                            </p>
                          </div>
                        ) : null
                      }
                    />
                    {/* Lagt til faste tallverdier på toppen av søylene for umiddelbar lesbarhet */}
                    <Bar
                      dataKey="profile"
                      radius={[6, 6, 0, 0]}
                      barSize={55}
                      isAnimationActive={false}
                      label={{ 
                        position: "top", 
                        fill: "#44403c", 
                        fontSize: 13, 
                        fontWeight: 700,
                        offset: 10,
                        formatter: (val) => `${val}%`
                      }}
                    >
                      {cur.map((e, i) => (
                        <Cell key={i} fill={e.color} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {cur.map((r) => (
                <div
                  key={r.key}
                  className="p-8 bg-stone-50 rounded-3xl border border-stone-200 flex flex-col justify-between"
                >
                  <div>
                    <p className="text-[10px] font-bold text-stone-400 uppercase tracking-[0.2em] mb-1">
                      {r.label}
                    </p>
                    <h3 className="font-bold text-stone-900 text-lg mb-4">{r.name}</h3>
                    <p className="text-sm text-stone-600 leading-relaxed mb-6 italic">
                      {r.desc}
                    </p>
                  </div>
                  <div className="h-1.5 w-full bg-stone-200 rounded-full overflow-hidden">
                    <div
                      className="h-full rounded-full"
                      style={{
                        width: `${r.profile}%`,
                        backgroundColor: r.color,
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
            <div className="pt-10 border-t border-stone-100 text-center mt-12 text-stone-300 text-[10px] uppercase font-bold tracking-[0.3em]">
              Lederskapsakademiet © {new Date().getFullYear()}
            </div>
          </div>
        </div>
        {!activeAnalysis && (
          <div className="max-w-5xl mx-auto mt-8 flex justify-center no-print">
            <button
              onClick={resetTest}
              className="text-stone-400 hover:text-stone-700 text-xs font-medium uppercase tracking-widest transition-all"
            >
              Lukk og start ny kartlegging
            </button>
          </div>
        )}
      </div>
    );
  }

  if (view === "admin" && isAdminAuthenticated) {
    const f = allAnalyses.filter(
      (a) =>
        a.name.toLowerCase().includes(search.toLowerCase()) ||
        a.email.toLowerCase().includes(search.toLowerCase())
    );
    return (
      <div className="min-h-screen bg-[#f9f8f7] p-6 font-sans text-stone-800">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center mb-10">
            <h1 className="text-3xl font-serif">Administrasjon</h1>
            <div className="flex gap-4">
              <button
                onClick={() => {
                  setIsAdminAuthenticated(false);
                  setView("welcome");
                }}
                className="text-stone-400 text-xs font-bold uppercase tracking-widest hover:text-stone-600 transition-colors"
              >
                LOGG UT
              </button>
              <button
                onClick={() => setView("welcome")}
                className="bg-stone-800 text-white px-5 py-2.5 rounded-xl text-sm font-medium shadow flex items-center gap-2"
              >
                <ArrowLeft size={16} /> Forside
              </button>
            </div>
          </div>
          <div className="bg-white rounded-3xl shadow-sm border border-stone-200 overflow-hidden">
            <div className="p-6 border-b border-stone-100 flex items-center gap-4 bg-stone-50/30">
              <div className="relative flex-1 max-w-md">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" size={18} />
                <input
                  type="text"
                  placeholder="Søk i kandidater..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 bg-white rounded-xl border border-stone-200 text-sm"
                />
              </div>
              <div className="text-[10px] font-black text-stone-400 uppercase tracking-widest px-4">
                Arkiv: {allAnalyses.length}
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead className="bg-stone-50/50 text-[10px] uppercase font-bold text-stone-500 tracking-[0.15em] border-b border-stone-200">
                  <tr>
                    <th className="px-8 py-6">Innsendt</th>
                    <th className="px-8 py-6">Kandidat</th>
                    <th className="px-8 py-6 text-right">Handlinger</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-stone-100">
                  {f.map((i) => (
                    <tr key={i.id} className="hover:bg-stone-50 transition-colors group">
                      <td className="px-8 py-6 text-xs text-stone-500">
                        {new Date(i.timestamp).toLocaleDateString("no-NO")}
                      </td>
                      <td className="px-8 py-6">
                        <div className="font-bold text-sm text-stone-900">{i.name}</div>
                        <div className="text-[10px] text-stone-500 font-medium">{i.email}</div>
                      </td>
                      <td className="px-8 py-6 text-right space-x-2">
                        <button
                          onClick={() => viewAnalysisFromAdmin(i)}
                          className="bg-stone-100 text-stone-700 px-4 py-2 rounded-lg hover:bg-stone-800 hover:text-white transition-all text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1.5 shadow-sm"
                        >
                          <Eye size={12} /> Se profil
                        </button>
                        <button
                          onClick={() => deleteFromAdmin(i.id)}
                          className="text-stone-300 hover:text-red-500 p-2"
                        >
                          <Trash2 size={18} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
}
